import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, of, catchError, Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private http = inject(HttpClient);
  private router = inject(Router);
  private isAuthenticated = false;

  checkSession(): Observable<any | null> {
    return this.http.post<any>(`${environment.apiUrl}/session`, {}, { withCredentials: true })
      .pipe(
        map(response => {
          this.isAuthenticated = true;
          return response.user;
        }),
        catchError(() => {
          this.isAuthenticated = false;
          return of(null);
        })
      );
  }

  encrypt(password: string) {
    return this.http.post<any>(`${environment.apiUrl}/encrypt`, { password: password }, { withCredentials: true });
  }

  login(credentials: { username: string; password: string }) {
    return this.http.post(`${environment.apiUrl}/login`, credentials, { withCredentials: true }).pipe(
      map((resp) => {
        this.isAuthenticated = true;
        return resp;
      })
    );
  }

  logout() {
    return this.http.post(`${environment.apiUrl}/logout`, {}, { withCredentials: true }).pipe(
      map(() => {
        this.isAuthenticated = false;
      })
    );
  }

  get loggedIn() {
    return this.isAuthenticated;
  }

  public isAdminPath(): boolean {
    // return this.router.url.startsWith('/admin');
    return window.location.pathname.startsWith('/admin');
  }

}
